export const errorId = (fieldId: string) => `${fieldId}-error`;
